import React, { Component } from 'react';
import * as actions from './actions';
import * as selectors from './selectors';
import { connect } from 'react-redux';
import { LoadingBlueLarge } from 'merchant-portal-components';

function getCombos(WrappedComponent) {
  class Container extends Component {
    componentDidMount() {
      if (!this.props.allCombos || this.props.allCombos.length === 0) {
        this.props.getCombos();
      }
    }

    componentDidUpdate(prevProps) {
      if (!prevProps.token && this.props.token) {
        this.props.getCombos();
      }
    }

    render() {
      const { requestingCombos, allCombos } = this.props;

      if (requestingCombos) {
        return <LoadingBlueLarge />;
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      allCombos: selectors.getAllCombos(state),
      requestingCombos: state.combos.requestingCombos,
      token: state.accountReducer.token,
    };
  }

  return connect(mapStateToProps, actions)(Container);
}

export default getCombos;
